import React, {useMemo} from 'react';
import {GlobalStyleAttributes} from '../../../../../../styles/GlobalStyles';
import {Colors} from '../../../../../../styles/Colors';
import HStack from '../../../../../common/Layout/HStack';
import VStack from '../../../../../common/Layout/VStack';
import AppText from '../../../../../common/AppText';
import {sortCourseEventDays} from '../../../../../../services/Helpers';
import TrackCourseSeriesEventRow from './TrackCourseSeriesEventRow';
import {isEventChecked, isEventDisabled} from './trackCourseSelectionHelpers';

const CourseFromTrack = (props) => {
    const {course, courses, trackSessionPerWeek, onSelect} = props;
    const series = course.series;
    const staffNames = [series?.coach, series?.second_coach]
        .filter(Boolean)
        .map(staff => `${staff.first_name} ${staff.last_name || ''}`.trim())
        .join(', ');
    const sortedSeriesEvents = useMemo(
        () => sortCourseEventDays(series.series_events ?? []),
        [series.series_events]
    );

    return (
        <VStack space={'0.5rem'}>
            <HStack space={'0.2rem'}>
                <AppText boldFont fontSize={GlobalStyleAttributes.fonts.heading3}>
                    {series.series_name}
                </AppText>
                {staffNames && (
                    <AppText color={Colors.newDesign.darkGrey} fontSize={GlobalStyleAttributes.fonts.standard16}>
                        {`- ${staffNames}`}
                    </AppText>
                )}
            </HStack>
            <VStack space={'0.35rem'} style={{paddingInlineStart: '0.25rem'}}>
                {sortedSeriesEvents.map(seriesEvent => (
                    <TrackCourseSeriesEventRow
                        key={seriesEvent.id}
                        seriesEvent={seriesEvent}
                        series={series}
                        onSelect={onSelect}
                        isDisabled={isEventDisabled({
                            series,
                            eventId: seriesEvent.id,
                            courses,
                            trackSessionPerWeek,
                            courseSessionPerWeek: course.session_per_week,
                        })}
                        isChecked={isEventChecked(courses, series.id, seriesEvent.id)}
                    />
                ))}
            </VStack>
        </VStack>
    );
};

export default CourseFromTrack;
